export const fallTransition = {
  enterActiveClass: 'transition-all ease duration-300 -translate-y-0',
  leaveActiveClass: 'transition-all ease duration-300 -translate-y-0',
  enterFromClass: 'opacity-0 -translate-y-40 z-0',
  leaveToClass: 'opacity-0 z-0',
}
